import fetch from "isomorphic-fetch";
import cloneDeep from "lodash/cloneDeep";

export const convertToCamelCase = (json) => {
  const transformedJson = cloneDeep(json);
  const jsonKeys = Object.keys(json);
  for (let i = 0; i < jsonKeys.length; i += 1) {
    const key = jsonKeys[i];
    const newKey = key.replace(/_[A-z]/g, (match) => match[1].toUpperCase());
    const value = json[key];
    if (key !== newKey) {
      delete transformedJson[key];
      transformedJson[newKey] = value;
    }
    if (value instanceof Object && !(value instanceof File || value instanceof Blob)) {
      transformedJson[newKey] = convertToCamelCase(value);
    }
  }

  return transformedJson;
};

export const convertToSnakeCase = (json) => {
  const transformedJson = cloneDeep(json);
  const jsonKeys = Object.keys(json);
  for (let i = 0; i < jsonKeys.length; i += 1) {
    const key = jsonKeys[i];
    const newKey = key.replace(/[a-z][A-Z]/g, (match) => `${match[0]}_${match[1]}`).toLowerCase();
    const value = json[key];
    if (key !== newKey) {
      delete transformedJson[key];
      transformedJson[newKey] = value;
    }
    if (value instanceof Object && !(value instanceof File || value instanceof Blob)) {
      transformedJson[newKey] = convertToSnakeCase(value);
    }
  }

  return transformedJson;
};

export const convertToJson = (response) =>
  response
    .json()
    .then((json) => ({
      ok: response.ok,
      body: json,
    }))
    .then((json) => convertToCamelCase(json))
    .then((json) => {
      if (!json.ok) {
        const error = {
          success: false,
          message: json.body.info,
          status: response.status,
        };
        throw error;
      }

      return json.body;
    });

const jsonFetch = (url, options = {}) => {
  const newOptions = options;
  if ("json" in newOptions) {
    const snakeCase = convertToSnakeCase(newOptions.json);
    newOptions.body = JSON.stringify(snakeCase);
  }
  const headers = {
    headers: {
      ...newOptions.headers,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetch(url, { ...newOptions, ...headers }).then((response) => convertToJson(response));
};

export default jsonFetch;
